<template>
  <div class="wrapper">
    <h1>该页面不存在</h1>
  </div>
</template>
<script>

export default {
  name: '',
  metaInfo: { title: '404' },
};
</script>

<style scoped>
h1 {
  font-size: 20px;
  text-align: center;
  padding: 40px 0;
}
</style>
